import { DisplayData, EarningsCalculatorStoreSlice, RequestInfo, RequestStatus } from './types';
import { reduxKey } from './constants';

function getState(state: any): EarningsCalculatorStoreSlice {
  if (!state[reduxKey]) {
    return {} as any;
  }
  return state[reduxKey];
}

export const getIsReduxLoaded = state => getState(state).isReduxLoaded;

export const getDisplayData = (state, displayId: string): DisplayData | undefined =>
  getState(state).displays?.[displayId];

export const getIsDisplayInitialized = (state, displayId: string) =>
  !!getDisplayData(state, displayId);

export const getActualPrice = (state, displayId: string): number =>
  getDisplayData(state, displayId)?.actualPrice ?? 0;

export const getEstimatedEarnings = (state, displayId: string): number =>
  getDisplayData(state, displayId)?.earnings ?? 0;

export const getRequestInfo = (state, displayId: string): RequestInfo =>
  getDisplayData(state, displayId)?.requestInfo ?? {
    status: RequestStatus.Idle,
  };

export const getServiceFeePercent = (state, displayId: string) =>
  getDisplayData(state, displayId)?.serviceFeePercentage;
